/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmUploadRequest
 */
export interface ConfirmUploadRequest {
    /**
     * Blob name returned from SAS token generation
     * @type {string}
     * @memberof ConfirmUploadRequest
     */
    blobName: string;
    /**
     * Original filename
     * @type {string}
     * @memberof ConfirmUploadRequest
     */
    filename: string;
    /**
     * MIME type of the file
     * @type {string}
     * @memberof ConfirmUploadRequest
     */
    mimeType: string;
    /**
     * File size in bytes
     * @type {number}
     * @memberof ConfirmUploadRequest
     */
    size: number;
}

/**
 * Check if a given object implements the ConfirmUploadRequest interface.
 */
export function instanceOfConfirmUploadRequest(value: object): value is ConfirmUploadRequest {
    if (!('blobName' in value) || value['blobName'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    return true;
}

export function ConfirmUploadRequestFromJSON(json: any): ConfirmUploadRequest {
    return ConfirmUploadRequestFromJSONTyped(json, false);
}

export function ConfirmUploadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmUploadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'blobName': json['blobName'],
        'filename': json['filename'],
        'mimeType': json['mimeType'],
        'size': json['size'],
    };
}

  export function ConfirmUploadRequestToJSON(json: any): ConfirmUploadRequest {
      return ConfirmUploadRequestToJSONTyped(json, false);
  }

  export function ConfirmUploadRequestToJSONTyped(value?: ConfirmUploadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'blobName': value['blobName'],
        'filename': value['filename'],
        'mimeType': value['mimeType'],
        'size': value['size'],
    };
}

